import { ColorGrid } from '@laranda/lib-sysutil';
import { Component, OnInit } from '@angular/core';
import { ControlDameVisitaCliente, AutenticaCli } from '@laranda/lib-ucontrol';
import { SysFecha, inicio_mes, fech_a_HTfech, HTfech_a_fech, fechaHoy, HTfechaHoy } from '@laranda/lib-sysutil';
import swal from 'sweetalert2';
import { FormControl } from '@angular/forms';
import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-visitas-cliente',
  templateUrl: './visitas-cliente.component.html',
  styleUrls: ['./visitas-cliente.component.scss']
})
export class VisitasClienteComponent implements OnInit {
  desde: string;
  hasta: string;
  totalHoras: number;
  fServicio: FormControl = new FormControl(' ');
  sysFecha = new SysFecha();

  dtColumnas: DataTables.ColumnSettings[] = [
    { title: this.colorGrid.tablaH('N° Visita'), data: 'Nuvisita' },
    { title: this.colorGrid.tablaH('Sistema'), data: 'Sistema' },
    { title: this.colorGrid.tablaH('Proyecto'), data: null, render: ( data, type, row, meta ) => {
      return data.Coproyecto + ' - ' + data.Txproyecto;
    }},
    { title: this.colorGrid.tablaH('Descripcion'), data: 'Descrip' },
    { title: this.colorGrid.tablaH('Fecha'), data: 'Flvisita' },
    { title: this.colorGrid.tablaH('Hora Desde'), data: 'Hrdesde' },
    { title: this.colorGrid.tablaH('Hora Hasta'), data: 'Hrhasta' },
    { title: this.colorGrid.tablaH('Horas'), data: 'Horas' },
    { title: this.colorGrid.tablaH('Analista'), data: 'Analista' }
  ];

  constructor(
    public controlDameVisitaCliente: ControlDameVisitaCliente,
    private autenticaCli: AutenticaCli,
    private colorGrid: ColorGrid
  ) { }

  ngOnInit(): void {
    this.fServicio.valueChanges.subscribe(valor => { this.controlDameVisitaCliente.ParamIn.tpservicio = valor; });
    if (this.controlDameVisitaCliente.ParamIn.desde !== '' && this.controlDameVisitaCliente.ParamIn.hasta !== '') {
      this.desde = fech_a_HTfech(this.controlDameVisitaCliente.ParamIn.desde);
      this.hasta = fech_a_HTfech(this.controlDameVisitaCliente.ParamIn.hasta);
    } else {
      this.desde = fech_a_HTfech(inicio_mes(fechaHoy()));
      this.hasta = HTfechaHoy();
    }

    if (this.controlDameVisitaCliente.ParamIn.tpservicio !== '') {
      this.fServicio.patchValue(this.controlDameVisitaCliente.ParamIn.tpservicio);
    }    

    // this.controlDameVisitaCliente.CadOut = [];
    this.controlDameVisitaCliente.ParamIn.tpservicio = ' ';
    this.totalHoras = 0;
    this.controlDameVisitaCliente.visible = true;
    this.autenticaCli.leerToken();
    
  }

  getBuscar() {
    this.totalHoras = 0;
    if (this.desde > this.hasta) {
      swal.fire('Error en Fechas', 'Fecha desde no pude ser mayor a la fecha hasta'  , 'error');
    } else {
      this.controlDameVisitaCliente.ParamIn.nucliente = +this.autenticaCli.CadOut.Numcli;
      this.controlDameVisitaCliente.ParamIn.desde = HTfech_a_fech(this.desde);
      this.controlDameVisitaCliente.ParamIn.hasta = HTfech_a_fech(this.hasta);      
      this.controlDameVisitaCliente.consultar();
      setTimeout(() => {        
        for (let control of this.controlDameVisitaCliente.CadOut) {
          this.totalHoras += parseFloat(control.Horas.replace(',','.'));
        }
      }, 2000);            
    }
  }
}
